import styled from 'styled-components';
import { BasicButton } from '../../../component/button';
import { Carousel } from '../../../component/carousel';
import { colors } from '../../../component/colors';
import { DropDown } from '../../../component/dropDown';
import { pxToRem } from '../../../utils/pxToRem';
import { AgentCard } from '../../agents/allAgents/component/agentCard';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 100px;
  margin-bottom: 25px;
`;
export const DetailsContainer = styled.div`
  padding: 23px 16px 0px 16px;
`;
export const Title = styled.p`
  font-family: DM Sans;
  font-size: ${pxToRem(21)};
  font-style: normal;
  font-weight: 500;
  line-height: ${pxToRem(29)};
  letter-spacing: 0.15000000596046448px;
  text-align: left;
`;
export const AddBtn = styled(BasicButton)`
  width: 120px;
  padding: 11px 0px;
  border-radius: 8px;
`;
export const Add = styled(DropDown)`
  width: 120px;
  background-color: ${colors.sojiOrange};
  #dropDownTxt {
    color: ${colors.white};
  }
  svg {
    fill: white;
  }
`;
export const EditBtn = styled(AddBtn)`
  background-color: ${colors.white};
  color: ${colors.sojiOrange};
  border: 1px solid ${colors.sojiOrange};
  margin-left: 24px;
`;
export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 16px;
  gap: 8px;
  margin-right: 24px;
  width: 280px;
  height: 32px;
  background: #ffffff;
  border-radius: 8px;
`;
export const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const SearchIcon = styled.img``;

export const SearchBar = styled.input`
  background-color: #ffffff;
  border: none;
  outline: none;

  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 400;
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(21)};
  letter-spacing: 0.1px;
  color: #a1a1a1;
  &::placeholder {
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 400;
    font-size: ${pxToRem(14)};
    line-height: ${pxToRem(21)};
    letter-spacing: 0.1px;
    color: #a1a1a1;
  }
`;
export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const Card = styled.div`
  background: #fafafb;
  border-radius: 16px;
  padding: 8px 8px 35px 8px;
  margin: 0px 10px;
  margin-bottom: 48px;
  flex: 1;
  max-width: 880px;

  @media (max-width: 500px) {
    margin: 0;
    margin-bottom: 48px;
  }
`;

export const StoreImage = styled(Carousel)`
  border-radius: 16px;
  width: 100%;
  height: 400px;
  max-width: 875px;
  object-fit: cover;
  background-color: #c4c4c4;
`;
export const Icon = styled.img`
  max-height: 48px;
  max-width: 48px;
`;

export const HeaderDetailContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StoreLocation = styled.div`
  font-weight: 500;
  margin-left: 4px;
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(19.6)};
  color: #a1a1a1;
  text-transform: capitalize;
`;
export const StoreName = styled.p`
  font-size: ${pxToRem(21)};
  font-style: normal;
  font-weight: 500;
  line-height: ${pxToRem(29)};
  letter-spacing: 0.15000000596046448px;
  text-transform: capitalize;
  text-align: left;
`;
export const IconRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 37px;
`;
export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const IconTitle = styled.p`
  font-size: ${pxToRem(12)};
  font-style: normal;
  font-weight: 400;
  line-height: ${pxToRem(14)};
  letter-spacing: 0px;
  text-align: center;
  margin-top: 8px;
`;

export const SectionHeader = styled(StoreName)`
  line-height: ${pxToRem(22.4)};
  font-size: ${pxToRem(16)};
  color: #32324b;
  margin-bottom: 16px;
  margin-top: 32px;
`;
export const HeaderIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const SectionDetails = styled.p`
  font-family: Inter;
  font-size: ${pxToRem(14)};
  text-transform: capitalize;
  font-weight: 400;
  line-height: ${pxToRem(23)};
  letter-spacing: 0em;
  text-align: left;
`;

export const RoomTypeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
`;
export const EmptyTxt = styled.p`
  font-size: ${pxToRem(16)};
  font-style: normal;
  font-weight: 500;
  line-height: ${pxToRem(22)};
  letter-spacing: 0px;
  text-align: left;
  margin-bottom: 32px;
`;

export const RightSidebar = styled.aside``;
export const CustomAgentCard = styled(AgentCard)`
  width: unset;
  flex: 0.4;
  margin: 0;
  margin-bottom: 20px;
  @media (max-width: 1000px) {
    width: unset;
    margin: 0px;
    margin-bottom: 48px;
  }
  @media (max-width: 730px) {
    width: auto;
    margin: 0;
    margin-bottom: 48px;
  }
`;
export const InfoContainer = styled.div``;
export const InfoCards = styled.div`
  background: #ffffff;
  border: 0.3px solid #fda800;
  box-shadow: 0px 8px 8px rgba(50, 50, 71, 0.08);
  border-radius: 8px;
  max-width: 96px;
  width: 100%;
  padding: 24px 40px;
  margin: 64px auto;
`;
export const InfoTitle = styled.h5`
  font-weight: 500;
  font-size: ${pxToRem(21)};
  line-height: ${pxToRem(29)};
  text-align: center;
  letter-spacing: 0.15px;
  color: #32324b;
`;
export const InfoValue = styled.p`
  font-weight: 500;
  font-size: ${pxToRem(21)};
  line-height: ${pxToRem(29)};
  text-align: center;
  letter-spacing: ${pxToRem(0.15)};
  color: #a1a1a1;
`;
